export function generateTimeOption(h_start = 0, assign_now_op = false) {
    let interval = 15;
    let mm_start = h_start * 60;
    const assign_now = {label: "Assign now", value: "now"}
    let timeOptions = []
    if(h_start > 0 && assign_now_op)
      timeOptions = [assign_now];
    for (var i=0;mm_start<24*60; i++) {
      var hh = Math.floor(mm_start/60); // getting hours of day in 0-24 format
      var mm = (mm_start%60); // getting minutes of the hour in 0-55 format
      let time = ("0" + (hh)).slice(-2) + ':' + ("0" + mm).slice(-2);
      timeOptions.push({label: time, value: time});
      mm_start = mm_start + interval;
    }
    return timeOptions;
  }
